module.exports = __webpack_public_path__ + "img/05c1e56.jpg";